import m from "../../geodata/es2015/usaTerritories2Low";
window.am4geodata_usaTerritories2Low = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/usaTerritories2Low.js
// module id = null
// module chunks = 